import { isRwNrPackingListRow } from './packingListRwNr';

function safe(s) {
  return s == null ? '' : String(s);
}

export function packingListContainerKey(r) {
  const c = safe(r?.container_celda).trim();
  if (c) return c;
  const excel = safe(r?._container_excel).trim();
  if (excel) return excel;
  return r?._container != null ? String(r._container) : '';
}

/** CD → RW → NR → resto (misma prioridad que mercancía PTC). */
export function gradoPackingListSortRank(row) {
  const g = safe(row?.grado_celda).trim().toUpperCase().replace(/\s+/g, ' ');
  if (g === 'CD') return 0;
  if (g === 'RW' || g === 'WR' || g === 'RW/NR') return 1;
  if (g === 'NR') return 2;
  if (/\bNR\b/.test(g) && !/\bRW\b/.test(g)) return 2;
  if (/\bRW\b/.test(g)) return 1;
  if (isRwNrPackingListRow(row)) {
    const txt = `${row?.grado_celda ?? ''} ${row?.productos_texto ?? ''}`.toUpperCase();
    if (/\bNR\b/.test(txt) && !/\bRW\b/.test(txt)) return 2;
    return 1;
  }
  return 50 + (g.charCodeAt(0) || 0);
}

/**
 * Dentro de cada contenedor, ordena filas CD → RW → NR sin cambiar el orden entre contenedores.
 */
export function sortPackingListDetailByGradeWithinContainer(rows) {
  const list = rows || [];
  if (list.length <= 1) return list.map((r) => ({ ...r }));

  const indexed = list.map((r, i) => ({ r, i }));
  const containerOrder = [];
  const byContainer = new Map();

  for (const { r, i } of indexed) {
    const ck = packingListContainerKey(r) || `__row_${i}`;
    if (!byContainer.has(ck)) {
      byContainer.set(ck, []);
      containerOrder.push(ck);
    }
    byContainer.get(ck).push({ r, i });
  }

  const out = [];
  for (const ck of containerOrder) {
    const group = byContainer.get(ck);
    group.sort((a, b) => {
      const gr = gradoPackingListSortRank(a.r) - gradoPackingListSortRank(b.r);
      if (gr !== 0) return gr;
      return a.i - b.i;
    });
    for (const { r } of group) out.push({ ...r });
  }
  return out;
}
